<template>
    <div class="row-style d-flex flex-column flex-md-row pb-3p-md-0">
        <BCol class="column-style">
            <div class="column-title">
                <p>Order Details</p>
            </div>
            <div class="details-info-table">
                <table class="table table-striped">
                    <tbody>
                        <tr>
                            <div class="table-row">
                                <div class="title">Order Number</div>
                                <div class="value">945-Y-23</div>
                            </div>
                        </tr>
                        <tr>
                            <div class="table-row">
                                <div class="title">Shop</div>
                                <div class="value">Shopify</div>
                            </div>
                        </tr>
                        <tr>
                            <div class="table-row">
                                <div class="title">Barcode</div>
                                <div class="value">PS0000000155624234</div>
                            </div>
                        </tr>
                        <tr>
                            <div class="table-row">
                                <div class="title">Status</div>
                                <div class="value">No label</div>
                            </div>
                        </tr>
                    </tbody>
                </table>
            </div>
        </BCol>
        <BCol class="column-style">
            <div class="column-title">
                <p>Customer Details</p>
            </div>
            <div class="details-info-table">
                <table class="table table-striped">
                    <tbody>
                        <tr>
                            <div class="table-row">
                                <div class="title">Customer Name / Company Name</div>
                                <div class="value">John Doe / Company Ltd.</div>
                            </div>
                        </tr>
                        <tr>
                            <div class="table-row">
                                <div class="title">Email Address</div>
                                <div class="value">johndoe@example.com</div>
                            </div>
                        </tr>
                        <tr>
                            <div class="table-row">
                                <div class="title">Destination Address</div>
                                <div class="value">Torenallee 20, 5613 BC Eindhoven, The Netherlands</div>
                            </div>
                        </tr>
                    </tbody>
                </table>
            </div>
        </BCol>
        <BCol class="column-style">
            <div class="column-title">
                <p>Shipping Details</p>
            </div>
            <BForm class="details-form">
                <div class="input-label">Sender Address</div>
                <div class="">
                    <BInputGroup class="input-group-dropdown">
                        <BFormInput @click="rotation" class="dropdown-input" v-model="selectedAddress" :disabled="true"></BFormInput>
                        <BInputGroupAppend>
                            <BButton class="dropdown-button">
                                <img @click="rotation" class="transition caret-img" v-bind:style="{transform: `rotate(${deg}deg)`}" src="~@/assets/pack_go/caret-right-icon.svg"/>
                            </BButton>
                        </BInputGroupAppend>
                        <div v-if="openDropdown" v-on:mouseleave="rotation" class="dropdown-menu dropdown-menu-floating" aria-labelledby="dropdownMenuButton">
                            <BInputGroup class="selection-group-input">
                                <template #append>
                                <BInputGroupText class="selection-group-input__text"><font-awesome-icon icon="search"/></BInputGroupText>
                                </template>
                                <BFormInput class="selection-group-input__input" v-model="search" placeholder="Search" :size="'sm'"></BFormInput>
                            </BInputGroup>
                            <div 
                                v-for="(address, addressInd) in addresses"
                                v-bind:key="addressInd"
                                class="dropdown-item selection-group-input__item"
                                :class="address === selectedAddress ? 'selection-group-input__item__selected' : ''"
                                @click="selectAddress(address)">{{ address }}
                            </div>
                        </div>
                    </BInputGroup>
                </div>
                <BRow style="margin-top: 16px">
                    <BCol cols="6">
                        <div class="input-label">Number of Parcels</div>
                        <BInputGroup class="inc-dec-input-group">
                            <BInputGroupPrepend>
                                <BButton @click="parcelNo--" class="inc-dec-btn__active" :disabled="parcelNo === 0">
                                    <img v-if="parcelNo !== 0" src="~@/assets/pack_go/dec-light-icon.svg"/>
                                    <img v-else src="~@/assets/pack_go/dec-dark-icon.svg"/>
                                </BButton>
                            </BInputGroupPrepend>

                            <BFormInput v-model="parcelNo" :disabled="true" class="inc-dec-input-group__input"></BFormInput>

                            <BInputGroupAppend>
                                <BButton @click="parcelNo++" class="inc-dec-btn__active" :disabled="parcelNo === 3">
                                    <img v-if="parcelNo !== 3" src="~@/assets/pack_go/inc-light-icon.svg"/>
                                    <img v-else src="~@/assets/pack_go/inc-dark-icon.svg"/>
                                </BButton>
                            </BInputGroupAppend>
                        </BInputGroup>
                    </BCol>
                    <BCol cols="6">
                        <div class="input-label">Parcel Weight</div>
                        <BInputGroup class="weight-input-group">
                            <BFormInput class="weight-input-group__input" type="number"></BFormInput>
                            <BInputGroupAppend>
                                <BInputGroupText class="weight-input-group__text">kg</BInputGroupText>
                            </BInputGroupAppend>
                        </BInputGroup>
                    </BCol>
                </BRow>
                <div class="mb-3 mb-md-0" style="margin-top: 16px">
                    <div class="input-label d-flex">
                        Box (Optional) <img style="margin-left: 4px;" src="~@/assets/pack_go/info-icon.svg"/>
                    </div>
                    <BInputGroup class="input-group-dropdown">
                        <BFormInput @click="boxRotation" class="dropdown-input" v-model="selectedBox" :disabled="true"></BFormInput>
                        <BInputGroupAppend>
                            <BButton class="dropdown-button">
                                <img  @click="boxRotation" class="transition" v-bind:style="{transform: `rotate(${boxDeg}deg)`}" src="~@/assets/pack_go/caret-right-icon.svg"/>
                            </BButton>
                        </BInputGroupAppend>
                        <div v-if="openBoxDropdown" v-on:mouseleave="boxRotation" class="dropdown-menu dropdown-menu-floating" aria-labelledby="dropdownMenuButton">
                            <BInputGroup class="selection-group-input">
                                <template #append>
                                <BInputGroupText class="selection-group-input__text"><font-awesome-icon icon="search"/></BInputGroupText>
                                </template>
                                <BFormInput class="selection-group-input__input" v-model="searchBox" placeholder="Search" :size="'sm'"></BFormInput>
                            </BInputGroup>
                            <div 
                                v-for="(box, boxInd) in boxes"
                                v-bind:key="boxInd"
                                class="dropdown-item selection-group-input__item"
                                :class="box === selectedBox ? 'selection-group-input__item__selected' : ''"
                                @click="selectBox(box)">{{ box }}
                            </div>
                        </div>
                    </BInputGroup>
                </div>
            </BForm>
        </BCol>
    </div>
</template>

<script>
import { BButton, BCol, BForm, BFormInput, BInputGroup, BInputGroupAppend, BInputGroupPrepend, BInputGroupText, BRow } from 'bootstrap-vue';

export default {
    components: {
        BRow,
        BCol,
        BForm,
        BFormInput,
        BInputGroupAppend,
        BInputGroup,
        BButton,
        BInputGroupText,
        BInputGroupPrepend
    },
    data() {
        return {
            deg: 90,
            boxDeg: 90,
            openDropdown: false,
            openBoxDropdown: false,
            selectedAddress: 'My Company, Eindhovenstraat 123, Eindhoven',
            selectedBox: 'Box 1 (10cm, 10cm, 10cm)',
            addresses: [
                'My Company, Eindhovenstraat 123, Eindhoven',
                'My Other Company, Boltonstraat 321, Eindhoven',
                'Home, Otherstraat 358, Nijmegen'
            ],
            addressList: [
                'My Company, Eindhovenstraat 123, Eindhoven',
                'My Other Company, Boltonstraat 321, Eindhoven',
                'Home, Otherstraat 358, Nijmegen'
            ],
            boxes: [
                'Box 1 (10cm, 10cm, 10cm)',
                'Box 2 (12cm, 12cm, 12cm)',
                'Box 3 (14cm, 14cm, 14cm)'
            ],
            boxList: [
                'Box 1 (10cm, 10cm, 10cm)',
                'Box 2 (12cm, 12cm, 12cm)',
                'Box 3 (14cm, 14cm, 14cm)'
            ],
            search: '',
            searchBox: '',
            parcelNo: 0
        }
    },
    watch: {
        search:function(val) {
            if(val === '') {
                this.addresses = this.addressList
            } else {
                const filteredAddresses = this.addressList.filter(address => 
                    address.toLowerCase().includes(val.toLowerCase())
                );

                this.addresses = filteredAddresses
            }
        },
        searchBox:function(val) {
            if(val === '') {
                this.boxes = this.boxList
            } else {
                const filteredBoxes = this.boxList.filter(boxes => 
                    boxes.toLowerCase().includes(val.toLowerCase())
                );

                this.boxes = filteredBoxes
            }
        }
    },
    methods: {
        rotation() {
            if(this.openDropdown) {
                this.deg = 90;
                this.openDropdown = false
            } else {
                this.deg = 270;
                this.openDropdown = true
            }
        },
        boxRotation() {
            if(this.openBoxDropdown) {
                this.boxDeg = 90;
                this.openBoxDropdown = false
            } else {
                this.boxDeg = 270;
                this.openBoxDropdown = true
            }
        },
        selectAddress(address) {
            this.selectedAddress = address
            this.openDropdown = false
            this.deg = 90;
        },
        selectBox(box) {
            this.selectedBox = box
            this.openBoxDropdown = false
            this.boxDeg = 90;
        }
    }
}
</script>

<style>
.row-style {
    border-top: 1px solid #C3C5C7;
}

.column-style {
    padding: 16;
}

.column-title {
    border-bottom: 1px solid #E7E7E7;
}

.column-title p{
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 0.9rem;
    line-height: 1px;
    color: #212121;
    margin-top: 20px;
}

.details-info-table {
    margin-top: 16px;
}

.table-row {
    padding: 12px;
}

.table-row .title{
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 0.7rem;
    color: #686868;
}

.table-row .value{
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 0.8rem;
    color: #212121;
}

.table-striped>tbody>tr:nth-child(odd) {
    background-color: #F5F6FA;;
}

.details-form {
    margin-top: 16px;
}

.input-label {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 0.7rem;
    color: #212121;
    line-height: 18px;
    margin-bottom: 8px;
}

.input-group-dropdown {
    width: 100% !important;
    border: 1px solid #112857;
    border-radius: 6px;
    position: relative;
    height: 2.3rem;
}

.dropdown-input {
    box-shadow: none !important;
    border: 0px solid #112857;
    outline: none;
    font-size: 0.8rem;
    height: 2rem;
}

.dropdown-input:disabled {
    box-shadow: none !important;
    border: 0px solid #112857;
    outline: none;
    background-color: #ffffff;
}

.dropdown-button {
    box-shadow: none !important;
    background-color: #ffffff;
    border: none;
    height: 2rem;
}

.dropdown-button:hover {
    background-color: #ffffff;
}

.dropdown-button:active {
    background-color: #ffffff !important;
}

.dropdown-button:focus {
    background-color: #ffffff !important;
}

.dropdown-menu-floating {
    position: absolute;
    z-index: 1000;
    display: block;
    width: 100%;
    padding: 5px 0;
    margin: 2px 0 0;
    font-size: 0.8rem;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
}

.selection-group-input {
    width: 100% !important;
    border-bottom: 1px solid #E7E7E7;
}

.selection-group-input:hover {
    background-color: #F4FAFF;
}

.selection-group-input__input {
    border: none;
    box-shadow: none;
    padding-left: 10px;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-size: 0.8rem;
}

.selection-group-input__input:focus {
    border: none;
    box-shadow: none;
}

.selection-group-input__text {
    border: none;
    background-color: #ffffff;
}

.selection-group-input__item {
    height: 30px;
    padding-left: 10px;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-size: 0.8rem;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
}

.selection-group-input__item__selected {
    background-color: #F4FAFF;
}

.selection-group-input__item:hover {
    background-color: #F4FAFF;
}

.inc-dec-input-group {
    width: 100% !important;
}

.inc-dec-input-group__input {
    height: 2rem;
    text-align: center;
}

.inc-dec-input-group__input:disabled {
    background-color: #ffffff;
}

.inc-dec-btn__active {
    width: 2rem;
    height: 2rem;
    background-color: #112857;
}

.inc-dec-btn__active img{
    width: 0.6rem;
    margin-bottom: 7px;
}

.inc-dec-btn__active:hover {
    background-color: #4D5E81;
}

.inc-dec-btn__active:disabled {
    background-color: #E7E7E7;
}

.weight-input-group {
    width: 100% !important;
}

.weight-input-group__text {
    background-color: #ffffff;
    border-left: none;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 900;
    font-size: 0.9rem;
    line-height: 20px;
    color: #212121;
}

.weight-input-group__input {
    background-color: #ffffff;
    border-right: none;
}

.weight-input-group__input:focus {
    box-shadow: none;
}
</style>